import React from 'react'
import styled from 'styled-components'

import NewCardAuctionInfo from '../NewCard/NewCardAuctionInfo'

const Component = styled.div`
  width: 100%;
`

const Preview = styled.div`
  position: relative;
  width: 100%; /* desired width */

  &:before {
    content: "";
    display: block;
    padding-top: 100%; /* initial ratio of 1:1*/
  }
`

const Content = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  background: black;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  &:before {
    padding-top: 200%;
  }
`

const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 12px;
  margin-top: 1rem;
`

const FooterName = styled.div`
  color: rgba(255, 255, 255, .7);
  font-weight: 600;
  margin-bottom: 4px;
`

const Video = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

// TODO: add some kind of lazy loading

const MiniCard = ({ tokenMetadata }) => {
  return (
    <Component>
      <Preview>
        <Content>
          <Video
            src={tokenMetadata.videoPreviewUri}
            autoPlay
            muted
            loop
            playsInline
          />
        </Content>
      </Preview>
      <Footer>
        <FooterName>
          {tokenMetadata.name}
        </FooterName>
        <NewCardAuctionInfo
          tokenMetadata={tokenMetadata}
          includeWinner={false}
        />
      </Footer>
    </Component>
  )
}

export default MiniCard
